import { prepareZXingModule } from 'barcode-detector/ponyfill';
import zxingReaderWasm from './assets/zxing_reader.wasm';

const wasmUrl = String(zxingReaderWasm);

prepareZXingModule({
  overrides: {
    locateFile: (path: string, prefix: string) => (path.endsWith('.wasm') ? wasmUrl : `${prefix}${path}`),
  },
});

export function configureWebBarcodeScanner(): void {}
